var $ = require('../internals/export');
var parseInt = require('../internals/number-parse-int');

// `Number.parseInt` method
// https://tc39.github.io/ecma262/#sec-number.parseint
$({ target: 'Number', stat: true, forced: Number.parseInt != parseInt }, {
  parseInt: parseInt
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.number.parse-int.js
// module id = 828
// module chunks = 3